import isArray from 'lodash/isArray';
import _pick from 'lodash/pick';
import actionTypes from '../actions/actionTypes';
import { mapInboxData } from '../utils/inbox'; // rebuild master

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  error: null,
  count: 0,
  dleChatCount: 0,
};

const mapConversation = (payload, message = {}) => {
  const unreadMessages = payload.notificationCount;
  return {
    ...message,
    lastMessageBody: payload.last_message || message.lastMessageBody,
    lastMessageType: payload.message_type || message.lastMessageType,
    internalEntityId: message.internalEntityId || null,
    dateCreated: payload.last_date_created || message.dateCreated,
    externalAddress: payload.contactId || message.externalAddress,
    externalEntityName: payload.contactName || message.externalEntityName,
    subject: payload.message_subject || message.subject,
    unreadMessagesCount: unreadMessages || unreadMessages === 0 ? unreadMessages : message.unreadMessagesCount,
    conversationId: message.conversationId || `${payload.associateId}-${payload.contactId}`,
    direction: message.direction,
    platformMessageId: message.platformMessageId,
    messageStatus: payload.message_inbox_status || message.messageStatus,
  };
};

const mapCallLog = (payload) => {
  const paths = [
    'conversationId',
    'platformMessageId',
    'externalAddress',
    'externalEntityName',
    'direction',
    'callDuration',
    'callStartTimestamp',
    'callEndTimestamp',
    'callStatus',
  ];
  const data = _pick(payload, paths);
  return {
    ...data,
    lastMessageBody: payload.last_message,
    lastMessageType: payload.message_type,
    internalEntityId: payload.internalAddress,
    dateCreated: payload.last_date_created,
    vanityName: payload.externalEntityName,
  };
};

const updateConversation = (data, payload) => {
  const isChatMessage = payload?.message_type === 'CHAT'; // eslint-disable-line
  const conversationId = `${payload.associateId}-${payload.contactId}`;
  let oldMessage;
  let restMessages;
  if (isChatMessage) {
    oldMessage = data?.find(
      (message) => message.internalEntityId === payload.associateId && message.externalAddress === payload.contactId,
    );
    restMessages = data.filter((message) => message.externalAddress !== payload?.contactId);
  } else {
    oldMessage = data?.find((message) => message.conversationId === conversationId);
    restMessages = data.filter((message) => message.conversationId !== conversationId);
  }

  const updatedMessage = mapConversation(payload, oldMessage);
  const foundIndex = data.findIndex((message) => message.conversationId === updatedMessage.conversationId);
  const allMessages = [...restMessages];

  if (foundIndex < 0) return [updatedMessage, ...allMessages];
  allMessages.splice(foundIndex, 0, updatedMessage);

  return allMessages;
};

const bunchUpdateConversation = (data, payload) => payload.reduce(updateConversation, [...data]);

export const inbox = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_CONVERSATIONS_V2_LOADING:
      return { ...state, isLoading: true };
    case actionTypes.GET_CONVERSATIONS_V2_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: [...state.data, ...mapInboxData(payload.items)],
        count: payload.count,
      };

    case actionTypes.GET_CONVERSATIONS_V2_DLE_SUCCESS:
      return {
        ...state,
        dleChatCount: payload,
      };
    case actionTypes.CLEAR_CONVERSATIONS:
      return {
        ...state,
        data: [],
        count: 0,
      };

    case actionTypes.UPDATE_CONVERSATION:
      return {
        ...state,
        data: isArray(payload) ? bunchUpdateConversation(state.data, payload) : updateConversation(state.data, payload),
      };
    case actionTypes.GET_CONVERSATIONS_V2_ERROR:
    case actionTypes.MARK_CALL_NOTIFICATION_ERROR:
      return { ...state, isLoading: false, error: payload };
    case actionTypes.GET_RELATED_PROFILES_SUCCESS:
      return {
        ...state,
        profiles: payload,
      };
    case actionTypes.CLEAR_RELATED_PROFILES:
      return {
        ...state,
        profiles: {},
      };
    case actionTypes.GET_RELATED_PROFILES_ERROR:
    case actionTypes.UPDATE_CALL_LOG_ERROR:
      return { ...state, error: payload };
    case actionTypes.UPDATE_CALL_LOG:
      return {
        ...state,
        data: [mapCallLog(payload), ...state.data],
      };
    default:
      return state;
  }
};

export default inbox;
